"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/SMSUndeliverableBanner.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _subscribers = require('shared/selectors/blobject/subscribers');
var _org = require('shared/selectors/org');
var _phone = require('shared/services/phone');
var _consent = require('shared/services/consent');






var _smsDelivery = require('shared/services/smsDelivery');
var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');

var _Form = require('web/components/Form');
var _SMSResubscribeModal = require('./SMSResubscribeModal'); var _SMSResubscribeModal2 = _interopRequireDefault(_SMSResubscribeModal);





 const SMS_UNDELIVERABLE_BANNER_TEST_ID = 'sms-undeliverable-banner'; exports.SMS_UNDELIVERABLE_BANNER_TEST_ID = SMS_UNDELIVERABLE_BANNER_TEST_ID









const BannerEntry = ({ entry, patientName, isMulti, isBusy, onClear }) => {
  const handleClick = _react.useCallback.call(void 0, () => onClear(entry), [onClear, entry])
  return (
    _react2.default.createElement('div', { className: "sms-undeliverable-banner--entry", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
      , _react2.default.createElement('div', { className: "sms-undeliverable-banner--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
        , _react2.default.createElement('span', { className: "sms-undeliverable-banner--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}},  entry.title )
        ,  !!entry.body && _react2.default.createElement('span', { className: "sms-undeliverable-banner--line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}},  entry.body ) 
        ,  !!entry.hint && _react2.default.createElement('span', { className: "sms-undeliverable-banner--line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}},  entry.hint ) 
      )
      ,  entry.clearAction && entry.clearLabel && (
        _react2.default.createElement(_Form.Button, {
          isOutlined: true,
          className: "sms-undeliverable-banner--btn",
          onClick: handleClick,
          isDisabled: isBusy,
          ariaLabel: `${entry.clearLabel} ${patientName || 'patient'}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}

          ,  isMulti ? `${entry.clearLabel} ${patientName}` : entry.clearLabel 
        )
      )
    )
  )
}

const MemoBannerEntry = _react.memo.call(void 0, BannerEntry)

// The one conversation banner for recipients BloomText won't text: opted
// out, blocked by the carrier, blocked by an admin, or a number that can't
// receive texts. Everyone sees why. Admins get the clear action only where
// an admin may clear the row (D4): Resubscribe for a staff-recorded opt-out
// (after confirming consent and giving a reason), Unblock for an admin
// block, Clear for a number that can't receive texts. Rows Twilio enforces (the
// patient's STOP, a carrier block, BloomText's notification number) have no
// button: only the patient's START lifts them, though in a consent org an
// admin can record that a patient who texted STOP asked again (the block
// stays). Sending is never blocked here;
// the backend refuses the text and marks the message.
const SMSUndeliverableBanner = ({ blobjectKey }) => {
  const selectBanner = _react.useMemo.call(void 0, _subscribers.makeSelectSMSUndeliverableBanner, [])
  const banner = _hooks.useAppSelector.call(void 0, state => selectBanner(state, blobjectKey))
  const hasConsent = _hooks.useAppSelector.call(void 0, state => !!banner.orgKey && _org.selectOrgHasConsent.call(void 0, state, banner.orgKey))
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const { isOpen, onOpen, onClose } = _useToggle2.default.call(void 0, )
  const [resubscribeKey, setResubscribeKey] = _react.useState(null)
  const [unblockingKey, setUnblockingKey] = _react.useState(null)

  const copy = _react.useMemo.call(void 0, 
    () => {
      const isAdmin = banner.isAdmin && !!banner.orgKey
      const base = _smsDelivery.makeSMSUndeliverableBannerCopy.call(void 0, {
        patients: banner.patients,
        recipientCount: banner.recipientCount,
        conversationType: banner.conversationType,
        chatNumbers: banner.chatNumbers,
        isAdmin,
      })
      return hasConsent ? _consent.withConsentAskedAgain.call(void 0, base, banner.patients, isAdmin) : base
    },
    [banner, hasConsent],
  )

  const patientsByKey = _react.useMemo.call(void 0, 
    () => new Map(banner.patients.map(p => [p.patient.PatientKey, p.patient])),
    [banner.patients],
  )
  const target = resubscribeKey ? patientsByKey.get(resubscribeKey) || null : null
  // In a consent org, Resubscribe on a texted STOP records "asked again".
  const textedStop = hasConsent ? _nullishCoalesce(_optionalChain([target, 'optionalAccess', _ => _.SMSUndeliverable, 'optionalAccess', _2 => _2.find, 'call', _3 => _3(_consent.isTextedStop)]), () => ( null)) : null
  const textedStopLine = textedStop
    ? _phone.formatPhoneNumber.call(void 0, textedStop.SendingNumber) || _phone.formatPhoneNumber.call(void 0, banner.chatNumbers[0]) || 'your number'
    : ''
  const orgKey = banner.orgKey

  const onClear = _react.useCallback.call(void 0, 
    (entry) => {
      if (!orgKey) return
      if (entry.clearAction === 'ResubscribePatientSMS') {
        setResubscribeKey(entry.patientKey)
        onOpen()
        return
      }
      if (entry.clearAction === 'UnblockPatientSMS') {
        const name = _optionalChain([patientsByKey, 'access', _4 => _4.get, 'call', _5 => _5(entry.patientKey), 'optionalAccess', _6 => _6.Name]) || 'Patient'
        setUnblockingKey(entry.patientKey)
        _actions2.default.unblockPatientSMS({ OrgKey: orgKey, PatientKey: entry.patientKey })
          .then(() => showSuccessBar(`${name}'s number unblocked`))
          .catch(e => showWarningBar(_smsDelivery.smsPreferenceErrorMessage.call(void 0, e, 'Failed to unblock number')))
          .finally(() => setUnblockingKey(null))
        return
      }
      if (entry.clearAction === 'ClearPatientSMSUnreachable') {
        setUnblockingKey(entry.patientKey)
        _actions2.default.clearPatientSMSUnreachable({ OrgKey: orgKey, PatientKey: entry.patientKey })
          .then(() => showSuccessBar(_smsDelivery.SMS_CLEAR_UNREACHABLE_SUCCESS))
          .catch(e => showWarningBar(_smsDelivery.smsPreferenceErrorMessage.call(void 0, e, _smsDelivery.SMS_CLEAR_UNREACHABLE_FAILURE)))
          .finally(() => setUnblockingKey(null))
      }
    },
    [orgKey, onOpen, patientsByKey, showSuccessBar, showWarningBar],
  )

  const onConfirmResubscribe = _react.useCallback.call(void 0, 
    (reason, askedAgain) => {
      if (!target || !orgKey) return Promise.resolve()
      return _actions2.default.resubscribePatientSMS({
        OrgKey: orgKey,
        PatientKey: target.PatientKey,
        ConfirmedPatientConsent: true,
        Reason: reason,
        ...(askedAgain && { How: askedAgain.how, AskedOn: askedAgain.askedOn }),
      })
        .then(() => {
          onClose()
          showSuccessBar(askedAgain
            ? _consent.makeAskedAgainSavedCopy.call(void 0, target.Name, textedStopLine)
            : `${target.Name || 'Patient'} resubscribed to texts`)
        })
        .catch(e => showWarningBar(_smsDelivery.smsPreferenceErrorMessage.call(void 0, e, 'Failed to resubscribe patient')))
    },
    [target, orgKey, onClose, showSuccessBar, showWarningBar, textedStopLine],
  )

  const remainingCopy = _react.useMemo.call(void 0, 
    () => target ? _smsDelivery.makeSMSResubscribeRemainingCopy.call(void 0, target.Name, target.SMSUndeliverable) : '',
    [target],
  )

  if (!copy.entries.length) return null
  const isMulti = copy.entries.length > 1

  return (
    _react2.default.createElement('div', { className: "sms-undeliverable-banner", role: "status", 'data-testid': exports.SMS_UNDELIVERABLE_BANNER_TEST_ID, __self: this, __source: {fileName: _jsxFileName, lineNumber: 170}}
      , _react2.default.createElement('img', { className: "sms-undeliverable-banner--icon", src: "/assets/icons/alert-orange.svg", alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 171}} )
      , _react2.default.createElement('div', { className: "sms-undeliverable-banner--entries", __self: this, __source: {fileName: _jsxFileName, lineNumber: 172}}
        ,  copy.entries.map(entry => (
          _react2.default.createElement(MemoBannerEntry, {
            key: entry.patientKey,
            entry: entry,
            patientName: _optionalChain([patientsByKey, 'access', _7 => _7.get, 'call', _8 => _8(entry.patientKey), 'optionalAccess', _9 => _9.Name]) || '',
            isMulti: isMulti,
            isBusy: unblockingKey === entry.patientKey,
            onClear: onClear, __self: this, __source: {fileName: _jsxFileName, lineNumber: 174}}
          )
        ))
        ,  copy.notes.map(note => (
          _react2.default.createElement('span', { key: note, className: "sms-undeliverable-banner--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 184}},  note )
        ))
      )
      , _react2.default.createElement(_SMSResubscribeModal2.default, {
        isOpen: isOpen,
        patientName: _optionalChain([target, 'optionalAccess', _10 => _10.Name]) || '',
        remainingCopy: remainingCopy,
        isAskedAgain: !!textedStop,
        onClose: onClose,
        onConfirm: onConfirmResubscribe, __self: this, __source: {fileName: _jsxFileName, lineNumber: 187}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, SMSUndeliverableBanner)
